import { mutationTypes } from './types'
import initialState from './initial-state'

export default {
  [mutationTypes.RESET_STATE]: (state, dirty) => {
    const initState = initialState()
    Object.keys(initState).forEach(key => { 
      state[key] = initState[key]
    })
  },
  [mutationTypes.GENERAL_ERROR]: (state, errors) => {
    state.errors = errors
  },
  [mutationTypes.LOGIN_PENDING]: (state) => {
    state.authenticating = true
    state.errors = []
    state.loginRedirect = null
  },
  [mutationTypes.LOGIN_FAILURE]: (state, errors) => {
    state.errors = errors
    state.authenticating = false
    state.loginRedirect = null
  },
  [mutationTypes.LOGIN_REDIRECT]: (state, redirectTo) => {
    state.authenticating = false
    state.errors = []
    state.loginRedirect = redirectTo
  },
  [mutationTypes.LOGIN_SUCCESS]: (state) => {
    state.authenticating = false
    state.errors = []
    state.loginRedirect = null
  },
  [mutationTypes.LOGOUT_PENDING]: (state) => {
    state.authenticating = true
    state.errors = []
  },
  [mutationTypes.LOGOUT_FAILURE]: (state, errors) => {
    state.errors = errors
    state.authenticating = false
  },
  [mutationTypes.LOGOUT_SUCCESS]: (state) => {
    state.authenticating = false
    state.errors = []
  },
  [mutationTypes.GET_REPORT_LIST_SUCCESS]: (state, reportList) => {
    state.reports = reportList
  },
  [mutationTypes.GET_REPORT_LIST_PENDING]: (state) => {
    state.reports = []
  },
  [mutationTypes.GET_REPORT_LIST_FAILURE]: (state, err) => {
    state.errors.push(err)
  },
  [mutationTypes.RETRIEVE_CURRENT_USER_SUCCESS]: (state, data) => {
    state.retrievingCurrentUser = false
    state.theme = data.theme
    state.userId = data.userId
    state.abilities = data.abilities
    state.startPage = data.startPage
  },
  [mutationTypes.RETRIEVE_CURRENT_USER_FAILURE]: (state) => {
    state.retrievingCurrentUser = false
  },
  [mutationTypes.RETRIEVE_CURRENT_USER_PENDING]: (state) => {
    state.retrievingCurrentUser = true
  },
  [mutationTypes.SET_LANGUAGE]: (state, language) => {
    state.language = language
  },
  [mutationTypes.SET_LOCALE]: (state, locale) => {
    state.locale = locale
  },
  [mutationTypes.SET_CONTINUATION_ROUTE]: (state, route) => {
    state.continuationRoute = route
  }
}
